import React from "react"
import Rating from "react-rating";

const Review = ({review, language}) => {
    return (
        <div className="row">
            <div className="col-md-6">
                <Rating
                    direction={language === 'ar' ? "rtl" : "ltr"}
                    initialRating={review.rate}
                    readonly
                    emptySymbol="fa fa-star-o font-20 empty-star"
                    fullSymbol="fa fa-star font-20 full-star"
                />
            </div>
            <div className="col-md-6">
                <p className="review-created-at">{review.created_at}</p>
            </div>
            <div className="col-md-12">
                <h5>{review.user ? review.user.name : null}</h5>
                <p>{review.content}</p>
            </div>
        </div>
    )
}

export default Review